export default function(values) {
  return Math.ceil(Math.log(values.length) / Math.LN2) + 1;
}



// WEBPACK FOOTER //
// C:/Dropbox/www/amcharts4dev/node_modules/d3-array/src/threshold/sturges.js